import React from 'react';

import HStack from 'common/ui/HStack';
import Skeleton from 'common/ui/Skeleton';
import VStack from 'common/ui/VStack';

const ActivitySkeleton = () => {
  return (
    <VStack className="gap-4">
      <Skeleton className="w-full h-8" />
      {Array.from({ length: 5 }).map((_, index) => (
        <VStack key={`comment-skeleton-${index}`} className="gap-2">
          <HStack className="items-center gap-2">
            <Skeleton className="size-8 !rounded-full" />
            <Skeleton className="w-full h-4" />
          </HStack>
          <Skeleton className="ml-10 h-4" />
          <HStack className="ml-10 items-center gap-2">
            <Skeleton className=" w-20 h-4" />
            <Skeleton className=" w-20 h-4" />
            <Skeleton className=" w-20 h-4" />
          </HStack>
        </VStack>
      ))}
    </VStack>
  );
};

export default ActivitySkeleton;
